<template>
  <a-form-model class="form" :model="form" ref="editForm" :rules="rules">
    <a-form-model-item label="链接">
      <a-input v-model="form.url" placeholder="图片跳转链接"></a-input>
    </a-form-model-item>
    <a-form-model-item label="图片">
      <cl-upload direct v-model="form.img"></cl-upload>
    </a-form-model-item>
    <a-form-model-item label="高度" prop="height">
      <a-input type="number" v-model="form.height"></a-input>
    </a-form-model-item>
    <a-form-model-item label="圆角">
      <a-input type="number" v-model="form.borderRadius"></a-input>
    </a-form-model-item>
    <a-form-model-item label="内层间距" v-if="form.padding">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.padding.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.padding.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.padding.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.padding.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="外层间距" v-if="form.margin">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.margin.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.margin.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.margin.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.margin.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="背景色">
      <colorPicker
        class="color-picker top shadow"
        v-model="form.backgroundColor"
      ></colorPicker>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import clUpload from "../cl-upload";
import { clone } from "../../common/js/tool";

export default {
  name: "banner-edit",
  components: {
    clUpload,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      form: {},
      rules: {
        height: [{ required: true, message: "请输入高度", trigger: "blur" }],
      },
      items: [],
    };
  },
  watch: {
    form: {
      handler() {
        this.update();
      },
      deep: true,
    },
    items: {
      handler() {
        this.update();
      },
      deep: true,
    },
    value() {
      this.setValue();
    },
  },
  created() {
    this.setValue();
  },
  methods: {
    setValue() {
      if (this.value) {
        let temp = clone(this.value);
        this.form = temp;
      }
    },
    update() {
      let temp = clone(this.form);
      this.$emit("change", temp);
    },
    validate() {
      let msg = null;
      this.$refs.editForm.validate((flag) => {
        if (!flag) {
          msg = "请正确填写表单项";
        }
      });
      if (!this.form.img) {
        msg = "请上传横幅图片";
      }
      return msg;
    },
  },
};
</script>

<style scoped lang="less">
.img-list {
  padding-left: 10px;
}
.img-item-form {
  position: relative;
  padding: 0 10px;
  background-color: var(--back-light-color);
  cursor: pointer;
  .el-icon-close {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background-color: var(--main-color);
    line-height: 20px;
    text-align: center;
    color: var(--back-white-color);
  }
}
.add-img {
  display: flex;
  align-items: center;
  padding: 0 10px;
  color: var(--main-color);
  cursor: pointer;
  .add-icon {
    margin-right: 6px;
    &::before,
    &::after {
      background-color: var(--main-color);
    }
  }
}
.inline-input {
  &:not(:first-of-type) {
    margin-left: 6px;
  }
}

.color-picker::v-deep {
  .colorBtn {
    width: 20px;
    height: 20px;
  }
}
</style>
